import styled, { css } from 'styled-components';
import {
  landscape,
  mediaDesktop,
  mediaTablet,
  mediaTabletAndPortrait,
} from 'utils/responsive';
import {
  MadeBonVoyage,
  MadeBonVoyageThin,
  NexaBlack,
} from 'utils/styles/typography';

export default styled.p`
  ${MadeBonVoyage};
  white-space: pre-line;
  font-size: 6.7vw;
  line-height: 8vw;
  margin: 0;
  b {
    ${NexaBlack};
  }
  i {
    font-style: normal;
    ${MadeBonVoyageThin};
  }
  ${landscape} {
    margin: 0 20% 0 0;
  }
  ${mediaTablet(css`
    font-size: 2.8vw;
    line-height: 3.4vw;
  `)}
  ${mediaTabletAndPortrait(css`
    font-size: 6vw;
    line-height: 7.1vw;
  `)}
  ${mediaDesktop(css`
    font-size: 3.2rem;
    line-height: 4rem;
  `)}
`;
